<template>
    <div id="commissions_table_component"
         class="commissions-table-component">
        <b-row style="margin-bottom: 24px;">
            <b-col lg="4" cols="12">
                <router-link :to="{name: 'MonthlyStatement'}"
                             class="button--primary">Monthly Statement</router-link>
            </b-col>
        </b-row>
        <b-row style="margin-bottom: 24px;">
            <b-col lg="3" cols="12">
                <p>Search by user</p>
                <dropdown-component
                        :autocomplete="true"
                        :searchUrl="api.user.tree.search"
                        :onElementClick="setUser">
                </dropdown-component>
            </b-col>
        </b-row>
        <div class="commissions-table-outer table-responsive">
            <div class="data-loader" v-if="loader"></div>
            <div class="table-outer">
                <table class="table-style1">
                    <thead>
                    <tr>
                        <th>
                            <div class="calendar-icon">
                                <p>Date</p>
                                <i class="mdi mdi-calendar"></i>
                                <datepicker placeholder="range"
                                            :options="{ mode: 'range', maxDate: 'today' }"
                                            v-model="date"></datepicker>
                            </div>
                        </th>

                        <th @click="changeSort('amount')">
                            <p>Income</p>
                            <div class="sort-icon">
                                <i class="mdi mdi-chevron-up"></i>
                                <i class="mdi mdi-chevron-down"></i>
                            </div>
                        </th>
                        <th>
                            <p>Bonus type</p>
                            <div class="filter-icon"
                                 @click="showFilter()">
                                <i class="mdi mdi-chevron-down"></i>
                            </div>
                            <bonus-filter v-if="filter"
                                          :filters="filters"></bonus-filter>
                        </th>
                        <th @click="changeSort('user')">
                            <p>From user</p>
                            <div class="sort-icon">
                                <i class="mdi mdi-chevron-up"></i>
                                <i class="mdi mdi-chevron-down"></i>
                            </div>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(commission, commissionId) in commissions"
                        :key="commissionId">
                        <td><p>{{ datetime.utcToLocal(commission.date) }}</p></td>
                        <td><p>FND {{ money.format(commission.amount.amount, 'fnd') }}</p></td>
                        <td><p>{{ filters[commission.type_name] }}</p></td>
                        <td><p>{{ commission.from_user }}</p></td>
                    </tr>
                    </tbody>
                </table>
                <p v-if="!commissions || commissions.length == 0" style="margin-top: 25px;">No results.</p>
            </div>
        </div>
        <pagination-component :current-page="currentPage"
                              :items="items"
                              :loader="loader"
                              :number-of-pages="numberOfPages"
                              :set-items="setItems"
                              :set-page="setPage"></pagination-component>
    </div>
</template>

<script>
    import BonusFilter from './commissions-table/BonusFilter.vue';
    export default {
        components: { BonusFilter },
        dependencies: ['api', 'datetime', 'money'],
        data () {
            return {
                date: '',
                filters: {
                    'direct-bonus-position'         : 'Direct Bonus',
                    'unilevel-bonus-position'       : 'Unilevel Bonus',
                    'direct-bonus-career-level'     : 'Career Sponsor Bonus',
                    'unilevel-bonus-career-level'   : 'Career Unilevel Bonus',
                    'matching-bonus'                : 'Matching Bonus',
                    'car-bonus'                     : 'Car Bonus',
                    'business-bonus'                : 'Business Bonus'
                },
                items: 25
            }
        },
        computed: {
            commissions () {
                return this.$store.getters.commissions ? this.$store.getters.commissions.results : [];
            },
            currentPage () {
                return this.$store.getters.commissionsSettings.currentPage;
            },
            filter () {
                return this.$store.getters.commissionsFilter;
            },
            loader () {
                return this.$store.getters.commissionsLoader;
            },
            maxPerPage () {
                return this.$store.getters.commissionsSettings.maxPerPage;
            },
            numberOfPages () {
                return this.$store.getters.commissionsSettings.numberOfPages;
            }
        },
        methods: {
            /**
             * Change sort
             */
            changeSort: function (field) {
                this.$store.dispatch('commissionsSetSort', field).then(() => {
                    this.getData();
                });
            },

            /**
             * Set default settings
             */
            clearSettings () {
                this.$store.dispatch('commissionsSettingsClear').then(() => {
                    this.getData();
                    this.items = 25;
                });
            },

            /**
             * Get data with transactions
             */
            getData () {
                let settings = this.$store.getters.commissionsSettings;

                this.$store.dispatch('loadCommissions', {
                    params: settings
                });
            },

            /**
             * Set number of items per page
             */
            setItems (items) {
                this.items = items
                this.$store.dispatch('commissionsSetItems', items).then(() => {
                    this.setPage(1);
                });
            },

            /**
             * Set current page
             * @param page
             */
            setPage (page) {
                this.$store.dispatch('commissionsSetPage', page).then(() => {
                    this.getData();
                    window.scrollTo(0,0);
                });
            },

            /**
             * Set user in filter
             */
            setUser (user) {
                this.$store.dispatch('commissionsSetUser', user).then(() => {
                    this.getData();
                });
            },

            /**
             * Show filter
             */
            showFilter () {
                this.$store.commit('commissionsFilterOn');
            }
        },
        watch: {
            /**
             * Get data with transactions if date in calendar was changed
             */
            date () {
                this.$store.dispatch('commissionsSetDate', this.date).then(() => {
                    this.getData();
                });
            }
        },
        beforeMount () {
            let settings = this.$store.getters.commissionsSettings

            this.$store.dispatch('loadCommissions', {
                params: settings
            }).then(() => {
                this.items = settings.maxPerPage
            })
        }
    }
</script>

<style lang="scss">
    .commissions-table-component{
        position: relative;
    }

    th{
        white-space: nowrap;

        p{
            display: inline-block;
            max-width: 85%;
            white-space: normal;
            vertical-align: middle;
            cursor: pointer;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/layout/partials/section/content/commissions/CommissionsTable.vue